import { eventDate, extractDate } from '../../helper';
import { Translate } from '../../config/TranslationProvider';

import styles from './EventDateDayRow.module.css';

const EventDateDayRow = ({ start, end, hasMoreDates, children }) => {
    const startDate = extractDate(start);
    const endDate = extractDate(end);

    if (!hasMoreDates || (startDate !== endDate)) {
        return (
            <p>
                <span className="la la-calendar" />
                {eventDate(start, end)}
                {children && <>
                    {', '}{children}
                </>}
            </p>
        );
    }

    return (
        <p
            className={styles.hasMultipleDates}
            onTouchStart={(e) => {
                // Show info on mobile via touch start event (usually info gets shown on hover)
                // We toggle the info box on multiple taps, except if the user taps directly onto the info box.
                if (e.target instanceof HTMLElement && !e.target.classList.contains(styles.info)) {
                    e.currentTarget.classList.toggle(styles.show);
                } else {
                    e.currentTarget.classList.add(styles.show);
                }
            }}
            onTouchEnd={(e) => {
                // Prevent click event on parent event card, so the info gets shown on mobile
                e.preventDefault();

                // Hide info when the user taps anywhere else
                const target = e.currentTarget;
                document.addEventListener('touchstart', (e) => {
                    if (target.isConnected && e.target instanceof Node && !target.contains(e.target)) {
                        target.classList.remove(styles.show);
                    }
                }, { once: true });
            }}
        >
            <span className="la la-calendar" />
            <span className={styles.date}>
                {eventDate(start, end)}
                {children && <>
                    {', '}{children}
                </>}
                {startDate === endDate && <>{' '}<Translate value="and_others" /></>}
            </span>
            <span className={`la la-info-circle ${styles.infoIcon}`} />

            <div className={styles.info}>
                <Translate value="event_multiple_dates_info" />
            </div>
        </p>
    );
};

export default EventDateDayRow;
